<template>
  <page
    :custom-style="{
      height: '100vh'
    }"
  >
    <ul v-if="buyRecordList.length" class="list">
      <li v-for="item in buyRecordList" :key="item.orderId" class="item">
        <div class="flex">
          <div class="title">
            {{ item.name }}
          </div>
          <div class="time">
            {{ item.ut }}
          </div>
        </div>
        <div class="flex right">
          <div class="money">
            ¥<span>{{ item.payAmount }}</span>
          </div>
          <div v-if="item.status === 0" class="btn" @click="goPay(item)">
            立即支付
          </div>
          <div v-else class="status">
            {{ item.status | statusName }}
          </div>
        </div>
      </li>
    </ul>
    <empty v-else text="暂无购买记录" />
  </page>
</template>
<script>
import Empty from '@/common/layout/empty/index'
import { API } from '@/api'
import { navBar } from '@/utils/native_interactions/native_bar'
import { mallDomain } from '@/defines/domains'
import { Bridge } from '@mc/mc-jsbridge'
import { nativeRedirect } from '@/utils/native_interactions/native_redirect'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
export default {
  filters: {
    statusName(value) {
      let name = ''
      switch (value) {
        case 3:
          name = '购买成功'
          break
        case 4:
          name = '退款成功'
          break
        case 5:
          name = '退款失败'
          break
        case 7:
          name = '退款中'
          break
      }
      return name
    }
  },
  components: {
    Empty
  },
  beforeRouteEnter(to, from, next) {
    next(v => {
      navBar.setTitle({
        text: '购买记录'
      })
      Bridge.call('navigatePageSetting', { edgeInsets: { edge: 0 } })
      v.getCouponPackBuyRecord()
    })
  },
  data() {
    return {
      buyRecordList: []
    }
  },
  mounted() {
    document.addEventListener('visibilitychange', this.pageShow)
  },
  methods: {
    pageShow() {
      if (!document.hidden) {
        this.getCouponPackBuyRecord()
      }
    },
    goPay(item) {
      const successUrl = `${mallDomain}/marketing/#/member-couponpack-success`
      API.memberCouponPack
        .getAgainCouponPackPayUrl({
          orderId: item.orderId,
          successUrl,
          backUrl: ''
        })
        .then(res => {
          nativeRedirect(nativeRoutes.cashier, {
            paySecret: encodeURIComponent(res.paySecret),
            agentId: res.agentId,
            successUrl,
            urlEncode: 1
          })
        })
        .catch(e => this.$catch(e))
    },
    getCouponPackBuyRecord() {
      API.memberCouponPack
        .getCouponPackBuyRecord({ pageNum: 1, pageSize: 500 })
        .then(res => {
          this.buyRecordList = res.items
        })
        .catch(e => {
          this.$catch(e)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.list {
  overflow-y: auto;
}
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.3rem 0.32rem;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: inset 0px -1px 0px 0px rgba(236, 236, 236, 1);
  .flex {
    display: flex;
    flex-direction: column;
    .right {
      align-items: center;
    }
  }
  .title {
    font-size: 0.32rem;
    color: #333;
    font-weight: 600;
  }
  .time {
    margin-top: 0.2rem;
    font-size: 0.26rem;
    color: #999;
  }
  .money {
    display: flex;
    align-items: flex-end;
    color: #333;
    font-size: 0.24rem;
    line-height: 0.24rem;
    font-weight: 600;
    span {
      font-size: 0.32rem;
    }
  }
  .status {
    margin-top: 0.2rem;
    width: 1.12rem;
    height: 0.32rem;
    line-height: 0.32rem;
    text-align: center;
    font-size: 0.22rem;
    border-radius: 0.04rem;
    color: rgba(255, 92, 0, 0.7);
    background-color: rgba(255, 92, 0, 0.04);
    border: 1px solid rgba(255, 92, 0, 0.1);
  }
  .btn {
    margin-top: 0.14rem;
    width: 1.32rem;
    height: 0.44rem;
    line-height: 0.44rem;
    text-align: center;
    font-size: 0.22rem;
    color: #fff;
    background-image: linear-gradient(to right, #ff7d5e 0%, #ff3410 100%);
    border-radius: 0.3rem;
  }
  .money,
  .status {
    width: 1.32rem;
    justify-content: center;
  }
}
.empty {
  color: #999;
}
</style>
